/* global Config */

// Vendor Libs
import React, {useEffect} from 'react';
import {Provider} from 'react-redux';
import {LocationProvider, Router, Redirect} from '@reach/router';
import {hot} from 'react-hot-loader/root';

// Styles
import './styles/app.scss';

// Redux
import store, {history} from './redux/store';

// Components
import AuthLayout from './components/AuthLayout';
import Kms from './components/Kms';

// main paths
const basePath = Config.base.basePath || '/';
const homePath = Config.base.homePath || '/kms/*';

const App = () => (
  <Provider store={store}>
    <LocationProvider history={history}>
      <Router>
        <AuthLayout path={basePath}>
          <Kms path={homePath} />
          <Redirect default={true} from={basePath} noThrow={true} to={homePath} />
        </AuthLayout>
      </Router>
    </LocationProvider>
  </Provider>
);

export default Config.base.env === 'development' ? hot(App) : App;
